module.exports = __webpack_public_path__ + "static/4-433c95544a767d56eea280254b02d8fc.jpg";